import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BehaviorSubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import { HelperService } from './helper.service';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private _language = new BehaviorSubject<String>('id');

  constructor(
    private http: HttpClient,
    private helper: HelperService,
  ) { }

  languageList() {
    return this.http.get<any>(
      `${environment.apiUrl}/api/language_list`
    );
  }

  setLanguage(lang: string) {
    this.helper.setStorage('language', lang);
    this._language.next(lang);
  }

  language() {
    return this._language.value;
  }

  getLanguageSetting() {
    return this.helper.getStorage('language');
  }

  loadPageLanguage(page:any) {
    return this.http.get<any>(
      `assets/language/${this._language.value}/${page}.json`
    );
  }
}
